import React from 'react';

export default function DashboardSustainabilityLegacy(props) {
    return (
        <div className="card border-0 rounded-15px bg-white shadow h-100 px-3">
            <div className="card-body card-widget">
                <div className={'row'}>
                    <div className={'col'}>
                        <h4 className="text-dark-blue">{$t('Social')}</h4>
                    </div>
                </div>
                <div className={'row'}>
                    <div className={'col'}>
                        <div className={'row my-3'}>
                            <div className={'col-12'}>
                                <div className={'row'}>
                                    <div className={'col-12'}>
                                        <div className={'row h-100'}>
                                            <div className={'col-12 col-lg-6'}>
                                                <div className="card border-0 rounded-15px bg-white shadow h-100">
                                                    <div className="card-body card-widget">
                                                        <div className={'d-flex flex-column justify-content-center h-100 p-3'}>
                                                            <h4 className={'text-blue mb-2'}>{$t('Female Athletes')} </h4>
                                                            <h3 className={'text-blue'}>{props.format(props.data.athletes_female_percent)} %</h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={'col-12 col-lg-6'}>
                                                <div className="card border-0 rounded-15px bg-white shadow h-100">
                                                    <div className="card-body card-widget">
                                                        <div className={'d-flex flex-column justify-content-center h-100 p-3'}>
                                                            <h4 className={'text-blue mb-2'}>{$t('Male Athletes')}</h4>
                                                            <h3 className={'text-blue'}>{props.format(props.data.athletes_male_percent)} %</h3>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
